import { Pipe, PipeTransform } from "@angular/core";
import { AssetHistoryDocumentStatus } from '@app/_models/enums/assetHistoryDocumentStatus';
import { Asset } from '@app/_models/_DTOs/asset';
import { AssetHistory } from '@app/_models/_DTOs/assetHistory';
import { InventoryFoundAsset } from '@app/_models/_DTOs/inventoryFoundAsset';
import { AssetViewModel } from '@app/_models/_viewModels/asset.viewmodel';
import { InventoryFoundAssetViewModel } from '@app/_models/_viewModels/inventoryFoundAsset.viewmodel';

@Pipe({
    name: 'sameBarCodeFoundAssets',
    pure: false
})
export class SameBarCodeFoundAssets implements PipeTransform {
    transform(value: InventoryFoundAssetViewModel, conflictingAssetNames: string[]): any {
        if(conflictingAssetNames != undefined && conflictingAssetNames.length > 0 && value.barCode != undefined && value.barCode.length > 0){
            return true;
        }
        return false;
    }
}